module.exports = __webpack_public_path__ + "img/slide-dog2.32d53aef.png";